<section>
  <div class="holder">
    <div class="mat-radio-group-holder">
      <mat-radio-group [(ngModel)]="currentCommand">
        @for (messageId of postMessageIds; track messageId) {
          <mat-radio-button [value]="messageId">{{ messageId }}</mat-radio-button>
        }
      </mat-radio-group>
    </div>
    <mat-form-field class="example-full-width">
      <mat-label>Value</mat-label>
      <input matInput [(ngModel)]="currentMessage" placeholder="Add a json depending on value" />
    </mat-form-field>
    <button mat-raised-button (click)="sendCollaboraPostMessage()">Post message</button>
  </div>
  <app-editor-iframe #editor [workspaceId]="workspaceId" [collaboraIframeUrl]="collaboraIframeUrl"> </app-editor-iframe>
</section>
